import { memo, useEffect, type ReactNode } from "react";
import { useLocation } from "react-router";

import { trackPageView } from "@/shared/lib/analytics";

/**
 * Sends GA4 virtual page_view on React Router navigations.
 * Must render under BrowserRouter. Does not render UI.
 */
export const AnalyticsProvider = memo(function AnalyticsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    trackPageView(path);
  }, [location.pathname, location.search]);

  return children;
});
